import React from 'react';
import { Row, Col } from 'antd';
import TabPaneCard from './TabPaneCard';
import TabPaneMobile from './TabPaneMobile';
import PropTypes from 'prop-types';

export default function TabPanes(props) {
  const {
    tabIndex,
    tabConfig,
    filters,
    itemData,
    destComponent,
    mobComponent,
    columnConfig,
    expandConfig,
    text,
    isLazyLoading,
    containerHeight,
    clicked
  } = props;

  return (
    <Row>
      <Col lg={24} md={0} xs={0}>
        <TabPaneCard
          isLazyLoading={isLazyLoading}
          itemData={itemData}
          tabIndex={tabIndex}
          length={itemData && itemData.length}
          tabConfig={tabConfig}
          filters={filters}
          tabComponent={destComponent}
          columnConfig={columnConfig}
          expandConfig={expandConfig}
          text={text}
          accountType={props.accountType}
          activeKey={props.activeKey}
          clicked={clicked}
          containerHeight={containerHeight}
        />
      </Col>
      <Col lg={0} md={24} xs={24}>
        <TabPaneMobile
          clicked={clicked}
          isLazyLoading={isLazyLoading}
          tabIndex={tabIndex}
          itemData={itemData}
          length={itemData && itemData.length}
          tabConfig={tabConfig}
          tabComponent={mobComponent}
          columnConfig={columnConfig}
          expandConfig={expandConfig}
          text={text}
          accountType={props.accountType}
          activeKey={props.activeKey}
        />
      </Col>
    </Row>
  );
}

TabPanes.propTypes = {
  clicked: PropTypes.func,
  isLazyLoading: PropTypes.bool,
  itemData: PropTypes.array,
  tabConfig: PropTypes.func,
  tabIndex: PropTypes.number,
  text: PropTypes.string,
  tabPanes: PropTypes.array,
  mobComponent: PropTypes.string
}